import HasID from "./HasID";
import {create, Delta} from "jsondiffpatch";

export interface History extends HasID {
    oldValue: string;
    newValue: string;
    updated: Date;
    updatedBy: string;
    noMeaningfulChanges?: boolean;
}

export function historyDiff(history: History): Delta | undefined {
    const jsondiffpatch = create({
        propertyFilter: function(name: string) {
            if (name == "Updated") return false;
            if (name == "UpdatedBy") return false;
            return true;
        },
        objectHash: function(obj: any, index: number) {
            // Use TaskQuestionId as the unique identifier for TaskAnswers
            if (obj.TaskQuestionId !== undefined) {
                return obj.TaskQuestionId;
            }
            // Use TaskId for TaskPatients, TaskPrescriptions, TaskAssignments
            if (obj.TaskId !== undefined) {
                return obj.TaskId;
            }
            // Default to array index
            return '$$index:' + index;
        }
    });

    let oldValue: any;
    if (history.oldValue) oldValue = JSON.parse(history.oldValue)[0];
    const newValue = JSON.parse(history.newValue)[0];

    Object.keys(newValue).forEach((h : any) => {
        if (Array.isArray(newValue[h]) && oldValue && !oldValue[h])
            oldValue[h] = [];
    })

    Object.keys(oldValue ?? {}).forEach((h : any) => {
        if (Array.isArray(oldValue[h]) && !newValue[h])
            newValue[h] = [];
    })

    return jsondiffpatch.diff(oldValue, newValue);
}
